
import AdUnit from '../components/AdUnit';
import React from 'react';
import { useLocation } from 'react-router-dom';
import useReveal from '../hooks/useReveal';
import { PageHero, FAQList } from '../components/shared';
import SaveButton from '../components/SaveButton';
import AffiliateBlock from '../components/AffiliateBlock';
import AdSlot from '../components/AdSlot';
import LeadForm from '../components/LeadForm';
import { Building2, Home as HomeIcon } from 'lucide-react';
import { GUIDE_PAGES } from '../mock';

// Renders Property or Business guide pages from a shared template.
const GuidePage = ({ which }) => {
  const location = useLocation();
  const key = which || (location.pathname.includes('business') ? 'business' : 'property');
  const p = GUIDE_PAGES[key];
  useReveal([key]);

  return (
    <div className="bg-[#F6F1E3]">
      <PageHero image={p.hero} alt={p.title} label={p.label} title={p.title} subtitle={p.subtitle} meta={p.meta} />
      <AdUnit slot="inline" />
      <article className="max-w-3xl mx-auto px-5 py-12 space-y-10">
        <div className="reveal flex justify-end">
          <SaveButton
            variant="pill"
            item={{ type: 'guide', ref_id: `guide-${key}`, title: p.title, subtitle: p.label, to: location.pathname }}
          />
        </div>
        {p.sections.map((s) => (
          <section key={s.heading} className="reveal">
            <h2 className="font-display text-[26px] font-semibold text-[#1B1D21]">{s.heading}</h2>
            <p className="mt-3 text-[17px] leading-relaxed text-[#3a4f63]">{s.body}</p>
          </section>
        ))}
        <section className="reveal">
          <h2 className="font-display text-[28px] font-semibold text-[#1B1D21] mb-5">Frequently asked questions</h2>
          <FAQList faqs={p.faqs} />
        </section>

        {/* Lead-gen + affiliate */}
        {key === 'business' ? (
          <section className="reveal">
            <LeadForm
              type="business"
              title="Set up your UAE company"
              blurb="Free-zone or mainland — get a tailored quote on licence, visa and bank-account setup from a UAE business-setup specialist."
              cta="Get a setup quote"
              icon={Building2}
              accent="#1B1D21"
            />
          </section>
        ) : (
          <section className="reveal">
            <LeadForm
              type="property"
              title="Enquire about UAE property"
              blurb="Buying or investing? Get matched with freehold listings and a RERA-registered agent in your target area."
              cta="Request property options"
              icon={HomeIcon}
              accent="#92722A"
            />
          </section>
        )}
        <section className="reveal">
          <AffiliateBlock placement={key} title="Helpful services" columns={2} />
        </section>
        <AdSlot slot="inContent" minH={140} className="reveal" />
      </article>
    </div>
  );
};

export default GuidePage;
